import {ReactComponent as TelegramIcon} from './telegram.svg'

function Telegram() {
  return <TelegramIcon />
}

export default Telegram
